const registryFunctionsUrl = `${import.meta.env.VITE_REGISTRY_SUPABASE_URL}/functions/v1`;

export interface SendEmailPayload {
  recipientEmails: string[];
  subject: string;
  textContent: string;
  timestamp?: string;
}

export const sendEmail = async (payload: SendEmailPayload) => {
  const registryAnonKey = import.meta.env.VITE_REGISTRY_SUPABASE_ANON_KEY;

  if (!registryAnonKey) {
    throw new Error("Missing VITE_REGISTRY_SUPABASE_ANON_KEY environment variable");
  }

  const response = await fetch(`${registryFunctionsUrl}/send-email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${registryAnonKey}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || "Error sending email");
  }

  return response.json();
};
